import React from 'react';
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import PaymentMethodSelect from "../../shared/PaymentMethodSelect";

const OplChooseMethod = () => {
  const { customer, setMethodStepData, paymentParameters, setPaymentParameters, contactId } = useOutletContext();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");
  const navigate = useNavigate()

  const onBankConfirmed = (institution) => {
    setMethodStepData({ method: "paybybank", institution });
    navigate(`/embeddedaccountpayment/confirmpaybybank?cu=${contactId}`);
  }

  return (paymentParameters && <div className="w-full flex flex-col items-center grow">
    <PaymentMethodSelect
      merchant={customer.merchant}
      paymentError={error}
      onPayByBankSelected={onBankConfirmed}
      paymentParameters={paymentParameters}
      processingUrl={`/embeddedaccountpayment/processing?cu=${contactId}`}
      successUrl={`/embeddedaccountpayment/success?cu=${contactId}`}
    />
  </div>);
}
export default OplChooseMethod;

